(() => {
class $159e43d92d725a35$var$AutoChecker extends HTMLElement {
    #controller = new AbortController();
    connectedCallback() {
        this.input = this.querySelector("input.input, textarea.textarea");
        this.checkbox = this.querySelector("input#handwritten-card");
        this.quantityInput = document.querySelector("buy-buttons .quantity-selector__input");
        this.increaseBtn = document.querySelector("buy-buttons .quantity-selector__button.increase");
        if (!this.input || !this.checkbox || !this.quantityInput || !this.increaseBtn) return;
        this.input.addEventListener("input", this.#handleInputChange.bind(this), {
            signal: this.#controller.signal
        });
    }
    #handleInputChange() {
        const currentValue = this.input.value;
        const maxLength = 250;
        if (currentValue.length > maxLength) this.input.value = currentValue.substring(0, maxLength);
        const hasText = this.input.value.trim().length > 0;
        this.checkbox.checked = hasText;
        this.#toggleQuantityLock(hasText);
    }
    #toggleQuantityLock(isChecked) {
        if (!this.quantityInput || !this.increaseBtn) return;
        if (isChecked) {
            this.quantityInput.value = 1;
            this.increaseBtn.disabled = true;
            this.quantityInput.setAttribute("max", "1");
        } else {
            this.increaseBtn.disabled = false;
            this.quantityInput.removeAttribute("max");
        }
    }
    disconnectedCallback() {
        this.#controller.abort();
    }
}
if (!customElements.get("auto-checker")) customElements.define("auto-checker", $159e43d92d725a35$var$AutoChecker);


document.addEventListener('cart-drawer:handle-hw-card-if-product-removed-in-checkout', (event)=>{
    const connectedProductsWithCards = event.target.querySelectorAll('cart-drawer [data-hw-group-id]');
    const groups = {};
    connectedProductsWithCards.forEach((el)=>{
        const id = el.getAttribute('data-hw-group-id');
        if (!groups[id]) groups[id] = [];
        groups[id].push(el);
    });
    // Find groups with only one remaining element and remove the product
    Object.values(groups).forEach((group)=>{
        if (group.length === 1) {
            const single = group[0];
            const removeBtn = single.querySelector('.line-item__remove-button');
            if (removeBtn) removeBtn.click();
        }
    });
});
document.addEventListener("cart-drawer:remove-connected-product", (event)=>{
    if (!event || !event.detail) return;
    const productToRemove = document.querySelector(`[data-hw-group-id="${event.detail.lineItemHwGroupId}"]`);
    if (productToRemove) productToRemove.querySelector('.line-item__remove-button').click();
});
class $d2db567b7d5eaa0a$var$MainCart extends HTMLElement {
    #controller = new AbortController();
    constructor(){
        super();
        this.signal = this.#controller.signal;
    }
    connectedCallback() {
        const hwGroupIdToRemove = sessionStorage.getItem('hw_group_id_to_remove');
        if (hwGroupIdToRemove) {
            const productToRemove = this.querySelector(`[data-hw-group-id="${hwGroupIdToRemove}"]`);
            if (productToRemove) productToRemove.querySelector('.remove-line-item').click();
            else sessionStorage.removeItem('hw_group_id_to_remove');
        }
        document.addEventListener('main-cart:remove-connected-product', (event)=>{
            const productToRemove = this.querySelector(`[data-hw-group-id="${event.detail.lineItemHwGroupId}"]`);
            if (productToRemove) sessionStorage.setItem('hw_group_id_to_remove', event.detail.lineItemHwGroupId);
        }, {
            signal: this.signal
        });
    }
    disconnectedCallback() {
        this.#controller.abort();
    }
}
if (!customElements.get('main-cart')) customElements.define('main-cart', $d2db567b7d5eaa0a$var$MainCart);


class $d4cd11ab062c4db2$var$ProductForm extends HTMLElement {
    #abortController;
    constructor(){
        super();
        this.#abortController = new AbortController();
    }
    connectedCallback() {
        const form = this.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        form.addEventListener("submit", this.handleSubmit.bind(this), {
            signal: this.#abortController.signal
        });
        form.id.disabled = false;
    }
    // Main submit handler: routes logic based on hw card conditions
    async handleSubmit(event) {
        event.preventDefault();
        const form = this.querySelector('form[action*="/cart/add"]');
        if (this.isBusy(event) || !form.checkValidity()) {
            form.reportValidity?.();
            return;
        }
        const showLoading = this.usesLoadingBar(event);
        const submitButtons = this.setLoadingState(form, true);
        const formData = new FormData(form);
        this.prepareSections(formData);
        const hw = this.extractHwData(event, formData);
        let responseJson;
        if (showLoading) this.startLoading();
        if (hw.shouldBundle) responseJson = await this.addBundledItems(hw, formData);
        else responseJson = await this.addStandardItem(formData);
        this.setLoadingState({
            elements: submitButtons
        }, false);
        if (showLoading) this.stopLoading();
        await this.processResponse(form, responseJson);
    }
    // ---- Helper Logic ---- //
    isBusy(event) {
        return event.submitter?.getAttribute("aria-busy") === "true";
    }
    usesLoadingBar(event) {
        return event.submitter?.querySelector("button-content") === null;
    }
    setLoadingState(form, isBusy) {
        const buttons = Array.from(form.elements).filter((el)=>el.type === "submit");
        buttons.forEach((btn)=>isBusy ? btn.setAttribute("aria-busy", "true") : btn.removeAttribute("aria-busy"));
        return buttons;
    }
    startLoading() {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", {
            bubbles: true
        }));
    }
    stopLoading() {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", {
            bubbles: true
        }));
    }
    prepareSections(formData) {
        const sectionsToBundle = new Set();
        document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: {
                sections: sectionsToBundle
            }
        }));
        formData.set("sections", [
            ...sectionsToBundle
        ].join(","));
    }
    extractHwData(event, formData) {
        const hwCardAdded = formData.get("properties[_hw_card_added]") === "on";
        const hwCardVariantId = formData.get("properties[_hw_card_variant_id]");
        const propertySelector = event?.target?.closest(".product-info__block-list")?.querySelector("auto-checker")?.getAttribute("data-hw-input-property-name");
        const hwInputPropertyName = propertySelector?.match(/properties\[(.+)\]/)?.[1] || propertySelector;
        const hwInputValue = (formData.get(propertySelector) || "").trim();
        if (!hwCardAdded) formData.delete(propertySelector);
        if (!hwInputValue) formData.delete("properties[_hw_card_added]");
        const shouldBundle = hwCardAdded && hwCardVariantId && hwInputValue && hwInputPropertyName;
        return {
            shouldBundle: shouldBundle,
            hwCardVariantId: hwCardVariantId,
            hwInputPropertyName: hwInputPropertyName,
            hwInputValue: hwInputValue,
            groupId: Date.now().toString()
        };
    }
    async addBundledItems(hw, formData) {
        const payload = {
            items: [
                {
                    id: Number(hw.hwCardVariantId),
                    quantity: 1,
                    properties: {
                        _hw_group_id: hw.groupId
                    }
                },
                {
                    id: Number(formData.get("id")),
                    quantity: 1,
                    properties: {
                        _hw_group_id: hw.groupId,
                        [hw.hwInputPropertyName]: hw.hwInputValue
                    }
                }
            ],
            sections: formData.get("sections")
        };
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        });
        return await response.json();
    }
    async addStandardItem(formData) {
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            }
        });
        return await response.json();
    }
    async processResponse(form, responseJson) {
        const response = responseJson;
        if (!response) {
            console.warn('No response received');
            return;
        }
        if (response.items || response.id) {
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent.sections = responseJson.sections;
            document.dispatchEvent(new CustomEvent("variant:add", {
                bubbles: true,
                detail: {
                    items: response.items || [
                        response
                    ],
                    cart: cartContent
                }
            }));
            document.dispatchEvent(new CustomEvent("cart:change", {
                bubbles: true,
                detail: {
                    cart: cartContent,
                    baseEvent: "variant:add"
                }
            }));
        } else document.dispatchEvent(new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
                error: responseJson.message
            }
        }));
    }
    disconnectedCallback() {
        this.#abortController.abort();
    }
}
if (!customElements.get('product-form')) customElements.define('product-form', $d4cd11ab062c4db2$var$ProductForm);


/**
 * Creates a debounced function that delays calling the provided function (fn)
 * until after wait milliseconds have elapsed since the last time
 * the debounced function was invoked. The returned function has a .cancel()
 * method to cancel any pending calls.
 *
 * @template {(...args: any[]) => any} T
 * @param {T} fn The function to debounce
 * @param {number} wait The time (in milliseconds) to wait before calling fn
 * @returns {T & { cancel(): void }} A debounced version of fn with a .cancel() method
 */ function $45b51576727f01a3$export$61fc7d43ac8f84b0(fn, wait) {
    /** @type {number | undefined} */ let timeout;
    /** @param {...any} args */ function debounced(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>fn.apply(this, args), wait);
    }
    // Add the .cancel method:
    debounced.cancel = ()=>{
        clearTimeout(timeout);
    };
    return /** @type {T & { cancel(): void }} */ debounced;
}


if (!customElements.get('stories-gallery')) {
    class StoriesGallery extends HTMLElement {
        constructor(){
            super();
            this.currentIndex = 0;
            this.autoAdvanceTimer = null;
            this.defaultStoryDuration = 8000; // TODO: Make it dynamic based on theme settings
            this.currentStoryDuration = this.defaultStoryDuration;
            this.touchStartX = 0;
            this.touchEndX = 0;
            this.activeItem = null;
            this._initElements();
            if (!this.closeButton || !this.buttonPrev || !this.buttonNext || !this.galleryItemsWrapper) return;
            if (!this.galleryItemsWrapper || !this.progressWrapper) return;
            if (!this.templates.gallery_item || !this.templates.progress_segment) return;
            this.teleportGalleryToTop();
            this.setCustomerActions();
            this.setupTouchEvents();
            this.startActions();
        }
        // DEFAULT METHODS 
        _initElements() {
            this.galleryItems = [];
            this.galleryItemsWrapper = this.querySelector('.stories-gallery__items');
            this.progressWrapper = this.querySelector('.stories-gallery__progress');
            this.progressBars = [];
            this.buttonPrev = this.querySelector('.stories-gallery__navigation--prev');
            this.buttonNext = this.querySelector('.stories-gallery__navigation--next');
            this.closeButton = this.querySelector('.stories-gallery__close');
            this.templates = {
                gallery_item: document.querySelector('template.stories-gallery__item'),
                progress_segment: document.querySelector('template#progress_segment')
            };
        }
        teleportGalleryToTop() {
            const mainContent = document.querySelector('main#main');
            if (!mainContent) {
                console.error("Cannot teleport gallery: main#main or StoriesGallery element not found.");
                return;
            }
            mainContent.insertAdjacentElement('afterend', this);
        }
        // EVENTS 
        setCustomerActions() {
            if (window.innerWidth > 768) {
                this.buttonPrev.addEventListener('click', this.onPrevClick.bind(this));
                this.buttonNext.addEventListener('click', this.onNextClick.bind(this));
            } else {
                if (this.buttonPrev) this.buttonPrev.style.display = 'none';
                if (this.buttonNext) this.buttonNext.style.display = 'none';
                this.galleryItemsWrapper.style.position = 'relative';
                this.galleryItemsWrapper.style.cursor = 'pointer';
                this.galleryItemsWrapper.addEventListener('click', this.handleGalleryClick.bind(this));
            }
            this.closeButton.addEventListener('click', this.onCloseButtonClicked.bind(this));
            this.addEventListener('click', (event)=>{
                if (event.target === this) this.onCloseButtonClicked();
            });
        }
        setupTouchEvents() {
            this.galleryItemsWrapper.addEventListener('touchstart', this.handleTouchStart.bind(this), {
                passive: true
            });
            this.galleryItemsWrapper.addEventListener('touchmove', this.handleTouchMove.bind(this), {
                passive: false
            });
            this.galleryItemsWrapper.addEventListener('touchend', this.handleTouchEnd.bind(this), {
                passive: true
            });
            this.debouncedResizeHandler = (0, $45b51576727f01a3$export$61fc7d43ac8f84b0)(this.handleResizeCheck.bind(this), 50);
            window.addEventListener('resize', this.debouncedResizeHandler);
        }
        handleResizeCheck() {
            if (window.innerWidth <= 768) {
                if (this.buttonPrev) this.buttonPrev.style.display = 'none';
                if (this.buttonNext) this.buttonNext.style.display = 'none';
            } else {
                if (this.buttonPrev) this.buttonPrev.style.display = '';
                if (this.buttonNext) this.buttonNext.style.display = '';
            }
        }
        handleGalleryClick(event) {
            if (window.innerWidth > 768) return;
            const clickX = event.clientX;
            const galleryRect = this.galleryItemsWrapper.getBoundingClientRect();
            const clickZoneWidth = 60;
            if (clickX - galleryRect.left < clickZoneWidth) this.onPrevClick(true);
            else if (galleryRect.right - clickX < clickZoneWidth) this.onNextClick(true);
        }
        handleTouchStart(event) {
            this.touchStartX = event.touches[0].clientX;
            this.touchEndX = this.touchStartX;
        }
        handleTouchMove(event) {
            if (event.touches.length > 1) return;
            this.touchEndX = event.touches[0].clientX;
            const xDiff = Math.abs(this.touchStartX - this.touchEndX);
            const yDiff = Math.abs(event.touches[0].clientY - this.touchStartY);
            if (xDiff > yDiff) event.preventDefault();
        }
        handleTouchEnd() {
            const minSwipeDistance = 50;
            const difference = this.touchStartX - this.touchEndX;
            if (Math.abs(difference) > minSwipeDistance) {
                if (difference > 0) this.onNextClick(true);
                else this.onPrevClick(true);
            }
        }
        listenToAllStoriesCompleted() {
            document.addEventListener('all-stories-completed', ()=>{
                this.onCloseButtonClicked();
            });
        }
        startActions() {
            this.currentIndex = this.getCurrentIndex();
            this.updateNavigationButtons();
            this.startAutoAdvance();
            this.listenToAllStoriesCompleted();
        }
        openGallery() {
            this.classList.add('active');
            this.onToggle(true);
        }
        onCloseButtonClicked() {
            this.classList.remove('active');
            this.onToggle(false);
            this.destructor();
        }
        // HELPERS 
        getCurrentIndex() {
            const activeItem = this.galleryItems.find((item)=>item.classList.contains('active'));
            if (activeItem) this.currentIndex = parseInt(activeItem.dataset.storyIndex) || 0;
            return this.currentIndex;
        }
        currentItemDuration() {
            const activeItem = this.galleryItems.find((item)=>item.classList.contains('active'));
            this.activeItem = activeItem;
            if (activeItem) return parseInt(activeItem.dataset.storyDuration) || this.defaultStoryDuration;
            return this.defaultStoryDuration;
        }
        destructor() {
            if (this.galleryItemsWrapper) {
                this.galleryItemsWrapper.innerHTML = '';
                this.galleryItemsWrapper.style.position = '';
                this.galleryItemsWrapper.style.cursor = '';
            }
            if (this.progressWrapper) this.progressWrapper.innerHTML = '';
            // Clean up event listeners
            window.removeEventListener('resize', this.handleResize);
            this.progressBars = [];
            this.galleryItems = [];
        }
        updateNavigationButtons() {
            if (!this.buttonPrev || !this.buttonNext) return;
            if (this.currentIndex === 0) {
                this.buttonPrev.style.opacity = '0.5';
                this.buttonPrev.style.pointerEvents = 'none';
            } else {
                this.buttonPrev.style.opacity = '1';
                this.buttonPrev.style.pointerEvents = 'auto';
            }
            if (this.currentIndex === this.galleryItems.length - 1) {
                this.buttonNext.style.opacity = '0.5';
                this.buttonNext.style.pointerEvents = 'none';
                this.buttonNext.cl;
            } else {
                this.buttonNext.style.opacity = '1';
                this.buttonNext.style.pointerEvents = 'auto';
            }
        }
        onToggle(open = true) {
            if (open) document.documentElement.setAttribute('scroll-lock', '');
            else document.documentElement.removeAttribute('scroll-lock');
        }
        // GALLERY CONTROLS
        onPrevClick(isMobile = false) {
            if (this.currentIndex > 0) this.goToSlide(this.currentIndex - 1, true, isMobile);
        }
        onNextClick(isMobile = false) {
            if (this.currentIndex < this.galleryItems.length - 1) this.goToSlide(this.currentIndex + 1, true, isMobile);
            else if (isMobile && window.innerWidth <= 768) this.onCloseButtonClicked();
        }
        goToSlide(index, isManual = false) {
            if (this.galleryItems[this.currentIndex]) this.galleryItems[this.currentIndex].classList.remove('active');
            this.currentIndex = index;
            if (this.galleryItems[this.currentIndex]) this.galleryItems[this.currentIndex].classList.add('active');
            this.currentStoryDuration = this.currentItemDuration();
            this.updateNavigationButtons();
            this.updateProgressBars();
            if (isManual) {
                this.stopAutoAdvance();
                this.startAutoAdvance();
            }
        }
        startAutoAdvance() {
            let isStoryVideo = false;
            if (this.activeItem) {
                isStoryVideo = this.activeItem.dataset.isStoryVideo === 'true';
                if (isStoryVideo) this.runStoryVideo();
            }
            this.stopAutoAdvance();
            this.autoAdvanceTimer = setTimeout(()=>{
                if (this.currentIndex < this.galleryItems.length - 1) {
                    this.goToSlide(this.currentIndex + 1, false);
                    this.startAutoAdvance();
                }
            }, this.currentStoryDuration);
        }
        runStoryVideo() {
            const video = this.activeItem.querySelector('video');
            if (!video) return;
            video.play();
        }
        stopAutoAdvance() {
            if (this.autoAdvanceTimer) {
                clearTimeout(this.autoAdvanceTimer);
                this.autoAdvanceTimer = null;
            }
        }
        // PROGRESS BAR
        initProgressBars() {
            const progressBarTemplate = this.templates.progress_segment;
            if (!progressBarTemplate) return;
            const progressBarTemplateContent = progressBarTemplate.content.cloneNode(true);
            if (this.galleryItems.length == 0) return;
            for(let i = 0; i < this.galleryItems.length; i++){
                const progressBar = progressBarTemplateContent.cloneNode(true);
                this.progressWrapper.appendChild(progressBar);
            }
            this.progressBars = Array.from(this.querySelectorAll('.stories-gallery__progress-bar'));
            if (this.progressBars.length > 0) this.updateProgressBars();
        }
        handleProgressBarAnimationEnd(bar) {
            if (!bar) return;
            bar.target.classList.add('completed');
            bar.target.removeEventListener('animationend', this.boundHandleAnimationEnd);
            // Check if all stories are completed
            const completedStories = this.progressBars.filter((bar)=>bar.classList.contains('completed'));
            if (completedStories.length === this.progressBars.length) document.dispatchEvent(new CustomEvent('all-stories-completed'));
        }
        updateProgressBars() {
            if (!this.progressBars) return;
            // Bind the handler to the instance
            this.boundHandleAnimationEnd = this.handleProgressBarAnimationEnd.bind(this);
            this.progressBars.forEach((bar, index)=>{
                bar.classList.remove('active-progress-bar', 'completed');
                if (index < this.currentIndex) {
                    bar.classList.add('completed');
                    bar.style.animation = 'none';
                } else if (index === this.currentIndex) {
                    bar.classList.add('active-progress-bar');
                    if (bar.classList.contains('active-progress-bar')) {
                        bar.style.animation = `progress-fill ${this.currentStoryDuration}ms linear forwards`;
                        bar.addEventListener('animationend', this.boundHandleAnimationEnd);
                    }
                } else if (index > this.currentIndex) bar.style.animation = 'none';
            });
        }
        // GALLERY ITEMS - build and render
        buildGalleryItems(targetElement) {
            if (!targetElement) {
                console.warn("can not build gallery items - targetElement not found");
                return false;
            }
            let stories = [];
            try {
                stories = JSON.parse(targetElement.textContent);
            } catch (error) {
                console.warn("can not build gallery items - error", error);
                return false;
            }
            if (stories.length === 0) {
                console.warn("can not build gallery items - stories array is empty");
                return false;
            }
            this.renderGalleryItems(stories);
            return true;
        }
        renderGalleryItems(stories) {
            const galleryItemTemplate = this.templates.gallery_item;
            if (!galleryItemTemplate) return;
            const galleryItemTemplateContent = galleryItemTemplate.content.cloneNode(true);
            for(let i = 0; i < stories.length; i++)this.renderGalleryItem(stories[i], galleryItemTemplateContent, i);
        }
        renderGalleryItem(story, galleryItemTemplateContent, index) {
            const mediaType = story.media_type;
            const { galleryItemElemets: galleryItemElemets, galleryItem: galleryItem } = this.setGalleryItemElements(story, galleryItemTemplateContent, index);
            if (!galleryItemElemets || !galleryItem) return;
            if (mediaType === 'Image' && !galleryItemElemets.image) return;
            if (mediaType === 'Video' && !galleryItemElemets.video) return;
            if (mediaType === 'Image') {
                galleryItemElemets.image.src = story.media;
                galleryItemElemets.image.classList.remove('hidden');
            } else if (mediaType === 'Video') {
                galleryItemElemets.video.src = story.media;
                galleryItemElemets.video.classList.remove('hidden');
            }
            if (galleryItemElemets.captionLink) galleryItemElemets.captionLink.href = story.page_redirection;
            if (galleryItemElemets.captionImage) {
                galleryItemElemets.captionImage.src = story.caption_image;
                if (galleryItemElemets.captionImage.src != '') galleryItemElemets.captionImage.classList.remove('hidden');
            }
            if (galleryItemElemets.captionText) galleryItemElemets.captionText.textContent = story.caption_text;
            if (galleryItemElemets.caption) galleryItemElemets.caption.style.backgroundColor = story.caption_color;
            this.galleryItemsWrapper.appendChild(galleryItem);
            if (this.galleryItemsWrapper) this.galleryItems = Array.from(this.galleryItemsWrapper.children);
        }
        setGalleryItemElements(story, galleryItemTemplateContent, index) {
            const galleryItem = galleryItemTemplateContent.cloneNode(true);
            if (!galleryItem) return;
            const galleryItemInner = galleryItem.querySelector('.stories-gallery__item--inner');
            if (!galleryItemInner) return;
            const galleryItemElemets = {
                image: galleryItemInner.querySelector('[story-image]'),
                video: galleryItemInner.querySelector('[story-video]'),
                caption: galleryItemInner.querySelector('[story-caption]'),
                captionLink: galleryItemInner.querySelector('[story-caption-link]'),
                captionImage: galleryItemInner.querySelector('[story-caption-image]'),
                captionText: galleryItemInner.querySelector('[story-caption-text]')
            };
            galleryItemInner.dataset.storyIndex = index || 0;
            galleryItemInner.dataset.storyId = story.id || '';
            galleryItemInner.dataset.storyDuration = story.duration || 8000;
            galleryItemInner.dataset.isStoryVideo = story.media_type === 'Video' ? 'true' : 'false';
            if (!galleryItemElemets.caption || !galleryItemElemets.captionLink || !galleryItemElemets.captionImage || !galleryItemElemets.captionText) return;
            return {
                galleryItemElemets: galleryItemElemets,
                galleryItem: galleryItem
            };
        }
    }
    customElements.define('stories-gallery', StoriesGallery);
}


if (!customElements.get('stories-highlight')) {
    class StoriesHighlight extends HTMLElement {
        constructor(){
            super();
            this.targetIndex = this.getAttribute('data-story-target-index');
            this.storiesGallery = document.querySelector('stories-gallery');
            this.targetElement = null;
            this.targetId = this.getAttribute('data-story-target-id');
            if (this.targetId) this.targetElement = document.querySelector(`script.product-stories[data-story-collection="${this.targetId}"]`);
            if (!this.targetElement) return;
            if (this.storiesGallery) this.addEventListener('click', this.onTargetElementClicked.bind(this));
        }
        onTargetElementClicked() {
            !this.classList.contains('has-seen') && this.classList.add('has-seen');
            const canBuildGalleryItems = this.storiesGallery.buildGalleryItems(this.targetElement);
            if (!canBuildGalleryItems) return;
            this.storiesGallery.initProgressBars();
            this.storiesGallery.goToSlide(0, true);
            this.storiesGallery.openGallery();
            this.storiesGallery.startActions();
        }
    }
    customElements.define('stories-highlight', StoriesHighlight);
}



})();
//# sourceMappingURL=parcel_scripts.js.map
